/*jshint esversion: 6 */
import store from '@/store/index';
import ViewStore from '@/store/modules/View.store.js';

function Template(payload) {
  let route = {
    path: 'wallet',
    name: 'ProjectWallet',
    component: () => import(
      
      `@/views/Project/ProjectWallet/ProjectWallet${ViewStore.getters['getUseOnSite']() ? 'OnSite' : ''}.view.vue`
    ),
    meta: {
      requiresAuth: true
    },
    props: (route) => {
      return {
        project_id: parseInt(route.params.project_id),
        snackbar: store.state.SnackBar.snackbar,
      };
    },
    redirect: {name: 'ProjectWalletTakt'},
  };
  if (payload && payload.children) {
    route.children = payload.children;
  }
  return route;
}
export default Template;
